'use client';

import { io, type Socket } from 'socket.io-client';

let sharedSocket: Socket | null = null;
let refCount = 0;

function getWebSocketUrl(): string {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4001';
  }

  if (typeof window !== 'undefined') {
    const apiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
    if (apiUrl) {
      return apiUrl.replace(/\/api\/?$/, '');
    }
    return window.location.origin;
  }

  return '';
}

function dispatchWindowEvent(name: string, detail: unknown) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  }
}

function registerGlobalHandlers(socket: Socket) {
  socket.on('force-logout', (data) => {
    dispatchWindowEvent('paction:force-logout', data);
  });

  socket.on('video-call-invite', (data) => {
    dispatchWindowEvent('paction:video-call-invite', data);
  });

  socket.on('video-call-accepted', (data) => {
    dispatchWindowEvent('paction:video-call-accepted', data);
  });

  socket.on('video-call-declined', (data) => {
    dispatchWindowEvent('paction:video-call-declined', data);
  });

  socket.on('video-call-ended', (data) => {
    dispatchWindowEvent('paction:video-call-ended', data);
  });

  if (process.env.NODE_ENV === 'development') {
    socket.on('connect_error', (error) => {
      // eslint-disable-next-line no-console
      console.warn('[WebSocket] Connection error:', error.message);
    });
  }
}

export function acquireSocket(): Socket | null {
  const url = getWebSocketUrl();
  if (!url) return null;

  if (!sharedSocket) {
    sharedSocket = io(url, {
      transports: ['websocket', 'polling'],
      upgrade: true,
      rememberUpgrade: true,
      timeout: 10000,
      forceNew: false,
      reconnection: true,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
      reconnectionAttempts: 5,
      withCredentials: true,
      autoConnect: false
    });
    registerGlobalHandlers(sharedSocket);
  }

  refCount++;
  return sharedSocket;
}

export function releaseSocket(): void {
  refCount--;
  if (refCount <= 0) {
    refCount = 0;
    if (sharedSocket) {
      sharedSocket.removeAllListeners();
      sharedSocket.disconnect();
      sharedSocket = null;
    }
  }
}

export function getSharedSocket(): Socket | null {
  return sharedSocket;
}
